import { useTheme } from 'antd-style'
import { isNil } from 'lodash'

import { createAbortiveExplainApi } from '@eastcoal/api/trade/abortiveExplain/createAbortiveExplain'
import { queryAbortiveExplainApi } from '@eastcoal/api/trade/abortiveExplain/queryAbortiveExplain'

import { GenericalRecord } from '@eastcoal/common/types/utilities'
import { pick } from '@eastcoal/common/utils/object'

import { CrudModalForm } from '@eastcoal/formily/components/CrudModalForm'
import { CancelButton } from '@eastcoal/formily/components/CrudModalForm/shared/CancelButton'
import { SubmitButton } from '@eastcoal/formily/components/CrudModalForm/shared/SubmitButton'

import { AbortiveExplainStatus } from '../../../enums/AbortiveExplainStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AuditButton } from './components/AuditButton'
import { AbortiveExplainFormModalProps } from './interface'
import { schema } from './schema'

const readApi: AbortiveExplainFormModalProps['readApi'] = ({ actionId }) => {
  return {
    api: (params: GenericalRecord) =>
      queryAbortiveExplainApi({ auctionId: actionId, ...params }),
    ready: !!actionId,
    refreshDeps: [actionId]
  }
}

const updateApi: AbortiveExplainFormModalProps['updateApi'] = values => {
  const formData = values
  return createAbortiveExplainApi({ ...formData })
}

export const AbortiveExplainFormModal = () => {
  const {
    tableRef,
    currentAuction,
    abortiveExplainVisible,
    setAbortiveExplainFormMode,
    abortiveExplainFormMode,
    toggleAbortiveExplainVisible
  } = useAuctionListStore(state =>
    pick(state, [
      'tableRef',
      'currentAuction',
      'abortiveExplainVisible',
      'setAbortiveExplainFormMode',
      'abortiveExplainFormMode',
      'toggleAbortiveExplainVisible'
    ])
  )

  const theme = useTheme()

  return (
    <CrudModalForm
      context={{ actionId: currentAuction?.id }}
      mode={abortiveExplainFormMode}
      name='abortiveExplainForm'
      open={abortiveExplainVisible}
      readApi={readApi}
      schema={schema}
      size={1200}
      title={currentAuction?.title}
      type='drawer'
      updateApi={updateApi}
      actions={[
        <CancelButton key='cancelButton' />,
        (isNil(currentAuction?.explainStatus) ||
          currentAuction?.explainStatus ===
            AbortiveExplainStatus.AUDIT_FAIL) && (
          <SubmitButton key='submitButton'>提交审核</SubmitButton>
        ),
        <AuditButton
          key='auditSuccessButton'
          auditStatus={AbortiveExplainStatus.AUDIT_SUCCESS}
        >
          通过
        </AuditButton>,
        <AuditButton
          key='auditFailButton'
          auditStatus={AbortiveExplainStatus.AUDIT_FAIL}
        >
          拒绝
        </AuditButton>
      ]}
      layout={{
        colon: false,
        labelWidth: 100
      }}
      styles={{
        body: {
          paddingBlock: theme.paddingXS
        }
      }}
      onModeChange={setAbortiveExplainFormMode}
      onOpenChange={toggleAbortiveExplainVisible}
      onSuccess={() => tableRef.current?.reload()}
    />
  )
}
